const pricingRules = [
  {
    quantity: "Pallet (1000 lbs.) Available West Coast Only - LIMIT 1",
    destinations: ["Nevada"],
    stoneSize: ["3 in. - 5 in."],
    shippingOption: ["Commercial", "Residential"],
    price: "$595.00",
    shopifyTitle:
      "Black Mexican Beach Pebbles (By the Pallet) | Pallet (1000 lbs.) | 3 in. - 5 in. | Nevada",
  },
  {
    quantity: "Pallet (1000 lbs.) Available West Coast Only - LIMIT 1",
    destinations: ["Oregon", "Washington", "California"],
    stoneSize: ["3 in. - 5 in."],
    shippingOption: ["Commercial", "Residential"],
    price: "$795.00",
    shopifyTitle:
      "Black Mexican Beach Pebbles (By the Pallet) | Pallet (1000 lbs.) | 3 in. - 5 in. | OR, WA, CA",
  },
  {
    quantity: "Pallet (1000 lbs.) Available West Coast Only - LIMIT 1",
    destinations: ["Oregon", "Washington", "California", "Nevada"],
    stoneSize: ["1 in. - 2 in.", "2 in. - 3 in."],
    shippingOption: ["Commercial", "Residential"],
    price: "$595.00",
    shopifyTitle:
      "Black Mexican Beach Pebbles (By the Pallet) | Pallet (1000 lbs.) | 1 in. - 2 in. or 2 in. - 3 in. | OR, WA, CA, NV",
  },
  {
    quantity: "Pallet (1000 lbs.) Available West Coast Only - LIMIT 1",
    destinations: [
      "Alabama",
      "Alaska",
      "Arizona",
      "Arkansas",
      "Colorado",
      "Connecticut",
      "Delaware",
      "Florida",
      "Georgia",
      "Hawaii",
      "Idaho",
      "Illinois",
      "Indiana",
      "Iowa",
      "Kansas",
      "Kentucky",
      "Louisiana",
      "Maine",
      "Maryland",
      "Massachusetts",
      "Michigan",
      "Minnesota",
      "Mississippi",
      "Missouri",
      "Montana",
      "Nebraska",
      "New Hampshire",
      "New Jersey",
      "New Mexico",
      "New York",
      "North Carolina",
      "North Dakota",
      "Ohio",
      "Oklahoma",
      "Pennsylvania",
      "Rhode Island",
      "South Carolina",
      "South Dakota",
      "Tennessee",
      "Texas",
      "Utah",
      "Vermont",
      "Virginia",
      "West Virginia",
      "Wisconsin",
      "Wyoming",
    ],
    stoneSize: ["1 in. - 2 in.", "2 in. - 3 in.", "3 in. - 5 in."],
    shippingOption: ["Commercial", "Residential"],
    price: "Not available",
    error:
      "Unavailable (Message: '1,000 lbs. Pallets are only available in CA, NV, WA, and OR. Limit 1 pallet.')",
  },
  {
    quantity: "Full Pallet (3000 lbs.)",
    destinations: [
      "Arizona",
      "Idaho",
      "Nevada",
      "New Mexico",
      "Oregon",
      "Utah",
      "Washington",
    ],
    stoneSize: ["1 in. - 2 in.", "2 in. - 3 in.", "3 in. - 5 in."],
    shippingOption: ["Commercial"],
    price: "$1,999.00",
    shopifyTitle:
      "Black Mexican Beach Pebbles (By the Pallet) | Full Pallet (3000 lbs.) | Commercial | AZ, ID, NV, NM, OR, UT, WA",
  },
  {
    quantity: "Full Pallet (3000 lbs.)",
    destinations: [
      "Arizona",
      "Idaho",
      "Nevada",
      "New Mexico",
      "Oregon",
      "Utah",
      "Washington",
    ],
    stoneSize: ["1 in. - 2 in.", "2 in. - 3 in.", "3 in. - 5 in."],
    shippingOption: ["Residential"],
    price: "$2,099.00",
    shopifyTitle:
      "Black Mexican Beach Pebbles (By the Pallet) | Full Pallet (3000 lbs.) | Residential | AZ, ID, NV, NM, OR, UT, WA",
  },
  {
    quantity: "Full Pallet (3000 lbs.)",
    destinations: [
      "California",
      "Colorado",
      "Kansas",
      "Montana",
      "Nebraska",
      "North Dakota",
      "Oklahoma",
      "South Dakota",
      "Wyoming",
    ],
    stoneSize: ["1 in. - 2 in.", "2 in. - 3 in.", "3 in. - 5 in."],
    shippingOption: ["Commercial"],
    price: "$2,099.00",
    shopifyTitle:
      "Black Mexican Beach Pebbles (By the Pallet) | Full Pallet (3000 lbs.) | Commercial | CA, CO, KS, MT, NE, ND, OK, SD, WY",
  },
  {
    quantity: "Full Pallet (3000 lbs.)",
    destinations: [
      "California",
      "Colorado",
      "Kansas",
      "Montana",
      "Nebraska",
      "North Dakota",
      "Oklahoma",
      "South Dakota",
      "Wyoming",
    ],
    stoneSize: ["1 in. - 2 in.", "2 in. - 3 in.", "3 in. - 5 in."],
    shippingOption: ["Residential"],
    price: "$2,199.00",
    shopifyTitle:
      "Black Mexican Beach Pebbles (By the Pallet) | Full Pallet (3000 lbs.) | Residential | CA, CO, KS, MT, NE, ND, OK, SD, WY",
  },
  {
    quantity: "Full Pallet (3000 lbs.)",
    destinations: [
      "Alabama",
      "Arkansas",
      "Illinois",
      "Indiana",
      "Iowa",
      "Kentucky",
      "Louisiana",
      "Michigan",
      "Minnesota",
      "Mississippi",
      "Missouri",
      "Ohio",
      "Tennessee",
      "Texas",
      "Wisconsin",
    ],
    stoneSize: ["1 in. - 2 in.", "2 in. - 3 in.", "3 in. - 5 in."],
    shippingOption: ["Commercial"],
    price: "$2,219.00",
    shopifyTitle:
      "Black Mexican Beach Pebbles (By the Pallet) | Full Pallet (3000 lbs.) | Commercial | AL, AR, IL, IN, IA, KY, LA, MI, MN, MS, MO, OH, TN, TX, WI",
  },
  {
    quantity: "Full Pallet (3000 lbs.)",
    destinations: [
      "Alabama",
      "Arkansas",
      "Illinois",
      "Indiana",
      "Iowa",
      "Kentucky",
      "Louisiana",
      "Michigan",
      "Minnesota",
      "Mississippi",
      "Missouri",
      "Ohio",
      "Tennessee",
      "Texas",
      "Wisconsin",
    ],
    stoneSize: ["1 in. - 2 in.", "2 in. - 3 in.", "3 in. - 5 in."],
    shippingOption: ["Residential"],
    price: "$2,319.00",
    shopifyTitle:
      "Black Mexican Beach Pebbles (By the Pallet) | Full Pallet (3000 lbs.) | Residential | AL, AR, IL, IN, IA, KY, LA, MI, MN, MS, MO, OH, TN, TX, WI",
  },
  {
    quantity: "Full Pallet (3000 lbs.)",
    destinations: [
      "Connecticut",
      "Delaware",
      "Georgia",
      "Maryland",
      "Massachusetts",
      "New Jersey",
      "New York",
      "North Carolina",
      "Pennsylvania",
      "Rhode Island",
      "South Carolina",
      "Virginia",
      "West Virginia",
    ],
    stoneSize: ["1 in. - 2 in.", "2 in. - 3 in.", "3 in. - 5 in."],
    shippingOption: ["Commercial"],
    price: "$2,399.00",
    shopifyTitle:
      "Black Mexican Beach Pebbles (By the Pallet) | Full Pallet (3000 lbs.) | Commercial | CT, DE, GA, MD, MA, NJ, NY, NC, PA, RI, SC, VA, WV",
  },
  {
    quantity: "Full Pallet (3000 lbs.)",
    destinations: [
      "Connecticut",
      "Delaware",
      "Georgia",
      "Maryland",
      "Massachusetts",
      "New Jersey",
      "New York",
      "North Carolina",
      "Pennsylvania",
      "Rhode Island",
      "South Carolina",
      "Virginia",
      "West Virginia",
    ],
    stoneSize: ["1 in. - 2 in.", "2 in. - 3 in.", "3 in. - 5 in."],
    shippingOption: ["Residential"],
    price: "$2,499.00",
    shopifyTitle:
      "Black Mexican Beach Pebbles (By the Pallet) | Full Pallet (3000 lbs.) | Residential | CT, DE, GA, MD, MA, NJ, NY, NC, PA, RI, SC, VA, WV",
  },
  {
    quantity: "Full Pallet (3000 lbs.)",
    destinations: ["Maine", "New Hampshire", "Vermont", "Florida"],
    stoneSize: ["1 in. - 2 in.", "2 in. - 3 in.", "3 in. - 5 in."],
    shippingOption: ["Commercial"],
    price: "$2,799.00",
    shopifyTitle:
      "Black Mexican Beach Pebbles (By the Pallet) | Full Pallet (3000 lbs.) | Commercial | ME, NH, VT, FL",
  },
  {
    quantity: "Full Pallet (3000 lbs.)",
    destinations: ["Maine", "New Hampshire", "Vermont", "Florida"],
    stoneSize: ["1 in. - 2 in.", "2 in. - 3 in.", "3 in. - 5 in."],
    shippingOption: ["Residential"],
    price: "$2,899.00",
    shopifyTitle:
      "Black Mexican Beach Pebbles (By the Pallet) | Full Pallet (3000 lbs.) | Residential | ME, NH, VT, FL",
  },
];

// main
initCustomPricing("$595.00");
